module.exports = __webpack_public_path__ + "img/Apisit.268cfe2e.jpg";